import rootStore from "./../stores/rootStore";
import CategoriesApi from "./category/CategoriesApi";
import DocumentsApi from "./document/DocumentsApi";
import JobsApi from "./jobs/JobsApi";
import ManufacturersApi from "./manufacturer/ManufacturersApi";
import MediaApi from "./media/MediaApi";
import OpportunitiesApi from "./opportunity/OpportunitiesApi";
import ProductsApi from "./product/ProductsApi";
import ResellersApi from "./reseller/ResellersApi";
import ReturnsApi from "./return/ReturnsApi";
import SearchApi from "./search/SearchApi";
import WarehousesApi from "./warehouses/WarehousesApi";

const manufacturerBaseUrl = import.meta.env.VITE_URL_MANUFACTURER as string;
const apiBaseUrl = import.meta.env.VITE_URL as string;

export interface IResponseProcessor {
  process(res: Response): void
}

class UnauthorizedResponseProcessor implements IResponseProcessor {
  process(res: Response): void {
    if (res.status === 401) {
      const customEvent = new CustomEvent("unauthorized_call");
      document.dispatchEvent(customEvent);
    }
  }
}

const processor = new UnauthorizedResponseProcessor();

const getToken = () => rootStore.userStore.user?.access_token || "";

/**
 * @deprecated This legacy API repository is being phased out in favor of RTK Query.
 * New data fetching logic should use hooks from the generated `randmar-api-client`.
 * This object is used by legacy MobX stores and will be removed once the migration is complete.
 */
const apiRepository = {
  categories: new CategoriesApi(manufacturerBaseUrl, getToken, processor),
  documents: new DocumentsApi(manufacturerBaseUrl, getToken, processor),
  manufacturers: new ManufacturersApi(apiBaseUrl, getToken, processor),
  opportunities: new OpportunitiesApi(manufacturerBaseUrl, getToken, processor),
  products: new ProductsApi(manufacturerBaseUrl, getToken, processor),
  resellers: new ResellersApi(manufacturerBaseUrl, getToken, processor),
  returns: new ReturnsApi(manufacturerBaseUrl, getToken, processor),
  search: new SearchApi(manufacturerBaseUrl, getToken, processor),
  warehouses: new WarehousesApi(apiBaseUrl, getToken, processor),
  media: new MediaApi(processor),
  jobs: new JobsApi(apiBaseUrl, getToken, processor),
};

export default apiRepository;
